<div class="h-full flex items-center">
    <si-language-switcher [availableLanguages]="availableLanguages"> </si-language-switcher>
</div>
